import { BlobNative } from "@pdfking/blob"
import type { CreateObjectURLType } from "@pdfking/compatibility"

export const CreateObjectURL: CreateObjectURLType = blob =>
  BlobNative(blob).then(URL.createObjectURL)
